module.exports = __webpack_public_path__ + "static/media/12_CAM.54d7eb23.png";